<template>
    <nav
        class="navigation-mobile"
        aria-label="Main navigation"
    >
        <button
            class="navigation-mobile__burger"
            :class="{'is-active': burgerMenu}"
            @click="toggleDropdown()"
            :aria-expanded="burgerMenu.toString()"
            aria-controls="mobile-menu"
            :aria-label="burgerMenu ? 'Закрыть меню' : 'Открыть меню'"
        >
            <z-icon class="navigation-mobile__burger--open" :name="icons.burger" />
            <z-icon class="navigation-mobile__burger--close" :name="icons.close" />
        </button>
        <div
          v-if="burgerMenu"
          class="navigation-mobile__dropdown"
          role="menu"
        >
            <navigation-mobile-body :icons="icons" />
        </div>
    </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mixinDevice } from '@/utils/mixin'
import NavigationMobileBody from './components/NavigationMobileBody.vue'
import NavigationMobileFooter from './components/NavigationMobileFooter.vue'

export default {
    name: 'navigation-mobile',
    emits: ['menuToggle'],
    mixins: [mixinDevice],
    components: {
        NavigationMobileFooter,
        NavigationMobileBody
    },
    props: {
        isIndex: Boolean,
        staticLinks: {
            type: Array,
            default: null
        },
        icons: {
            type: Object,
            default: () => ({
                burger: 'tools/burger',
                close: 'tools/close-small',
                external: 'link/external',
                backlink: 'arrows/caret-light',
                link: 'arrows/caret-light'
            })
        }
    },
    computed: {
        ...mapGetters(['burgerMenu'])
    },
    watch: {
        burgerMenu(next) {
            let header = document.querySelector('.header')

            header.classList.toggle('is-open', next && header)
            document.body.classList.toggle('is-disabled', next && header)
            document.body.classList.toggle('mobile-nav-opened', next && header)
            this.$emit('menuToggle', next)
        },
        device (newVal) {
            const isSmallScreen = ['tablet', 'v-tablet', 'mobile'].includes(newVal)

            if (!isSmallScreen && this.burgerMenu) {
                this.toggleDropdown()
            }
        }

    },
    methods: {
        ...mapActions(['ToggleBurgerMenuAction']),
        toggleDropdown() {
            this.ToggleBurgerMenuAction()
        }
    }
}
</script>

<style lang="scss">
@import 'vars';

.navigation-mobile {
    $parent: &;
    display: flex;
    height: 100%;
    align-items: center;

    a {
        text-decoration: none;
        color: inherit;
    }

    &__burger {
        position: relative;
        display: block;
        padding: 0;
        width: 40px;
        height: 40px;
        z-index: 11;
        border: none;
        background: transparent;

        .z-icon {
            width: 100%;
            height: 100%;
        }

        &--open {
            display: block;

            .is-active & {
                display: none;
            }

            path {
                fill: var(--color-white);
            }
        }

        &--close {
            display: none;

            .is-active & {
                display: block;

                path {
                    fill-opacity: 0.6;
                    fill: var(--color-white);
                }
            }
        }
    }

    &__dropdown {
        position: fixed;
        top: 153px; // header height
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        background-color: var(--color-primary);

        @include breakpoint(v-tablet) {
            top: 129px;
        }

        @include breakpoint(mobile) {
            top: 87px;
        }
    }
}
</style>
